import React, { useState } from 'react';
import { User, Lock, Bell, Building2, Save } from 'lucide-react';
interface SettingsProps {
  type: 'buyer' | 'seller';
}
export const Settings = ({
  type
}: SettingsProps) => {
  const [activeTab, setActiveTab] = useState('profile');
  const tabs = [{
    id: 'profile',
    label: 'Profile',
    icon: User
  }, ...(type === 'seller' ? [{
    id: 'business',
    label: 'Business Info',
    icon: Building2
  }] : []), {
    id: 'security',
    label: 'Security',
    icon: Lock
  }, {
    id: 'notifications',
    label: 'Notifications',
    icon: Bell
  }];
  return <div className="space-y-6 animate-in fade-in" data-id="element-1544">
      <div data-id="element-1545">
        <h1 className="text-2xl font-serif font-bold text-primary-900 mb-1" data-id="element-1546">
          Settings
        </h1>
        <p className="text-text-light" data-id="element-1547">
          Manage your account preferences and security.
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-8" data-id="element-1548">
        {/* Sidebar Tabs */}
        <div className="w-full md:w-64 shrink-0 space-y-1" data-id="element-1549">
          {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition-colors ${isActive ? 'bg-primary-900 text-white shadow-md' : 'text-text-light hover:bg-neutral-200 hover:text-text'}`} data-id="element-1550">
                <Icon size={18} data-id="element-1551" /> {tab.label}
              </button>;
        })}
        </div>

        {/* Content Area */}
        <div className="flex-grow bg-white rounded-2xl shadow-sm border border-neutral-200 p-6 md:p-8" data-id="element-1552">
          {activeTab === 'profile' && <div className="space-y-6 animate-in fade-in" data-id="element-1553">
              <h2 className="text-lg font-serif font-bold text-primary-900 mb-6" data-id="element-1554">
                Personal Information
              </h2>

              <div className="flex items-center gap-6 mb-8" data-id="element-1555">
                <div className="w-20 h-20 rounded-full bg-primary-50 text-primary-900 flex items-center justify-center text-2xl font-serif font-bold border-2 border-primary-100" data-id="element-1556">
                  JD
                </div>
                <div data-id="element-1557">
                  <button className="px-4 py-2 bg-white border border-neutral-200 rounded-lg text-sm font-bold text-text hover:bg-neutral-50 transition-colors mb-2" data-id="element-1558">
                    Change Avatar
                  </button>
                  <p className="text-xs text-text-light" data-id="element-1559">
                    JPG, GIF or PNG. Max size of 800K
                  </p>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6" data-id="element-1560">
                <div data-id="element-1561">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1562">
                    Full Name
                  </label>
                  <input type="text" defaultValue="John Doe" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1563" />
                </div>
                <div data-id="element-1564">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1565">
                    Email Address
                  </label>
                  <input type="email" defaultValue="john@example.com" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1566" />
                </div>
                <div data-id="element-1567">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1568">
                    Phone Number
                  </label>
                  <input type="tel" defaultValue="+234 800 000 0000" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1569" />
                </div>
              </div>

              <div className="pt-6 border-t border-neutral-100 flex justify-end" data-id="element-1570">
                <button className="flex items-center gap-2 bg-primary-900 hover:bg-primary-800 text-white px-6 py-3 rounded-xl font-bold transition-colors shadow-lg" data-id="element-1571">
                  <Save size={18} data-id="element-1572" /> Save Changes
                </button>
              </div>
            </div>}

          {activeTab === 'business' && type === 'seller' && <div className="space-y-6 animate-in fade-in" data-id="element-1573">
              <h2 className="text-lg font-serif font-bold text-primary-900 mb-6" data-id="element-1574">
                Business Information
              </h2>
              <div className="grid md:grid-cols-2 gap-6" data-id="element-1575">
                <div data-id="element-1576">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1577">
                    Company Name
                  </label>
                  <input type="text" defaultValue="Premium Homes Ltd" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1578" />
                </div>
                <div data-id="element-1579">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1580">
                    RC Number
                  </label>
                  <input type="text" defaultValue="RC123456" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1581" />
                </div>
                <div className="md:col-span-2" data-id="element-1582">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1583">
                    Office Address
                  </label>
                  <input type="text" defaultValue="14 Maitama Crescent, Abuja" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1584" />
                </div>
              </div>
              <div className="pt-6 border-t border-neutral-100 flex justify-end" data-id="element-1585">
                <button className="flex items-center gap-2 bg-primary-900 hover:bg-primary-800 text-white px-6 py-3 rounded-xl font-bold transition-colors shadow-lg" data-id="element-1586">
                  <Save size={18} data-id="element-1587" /> Save Business Info
                </button>
              </div>
            </div>}

          {activeTab === 'security' && <div className="space-y-6 animate-in fade-in" data-id="element-1588">
              <h2 className="text-lg font-serif font-bold text-primary-900 mb-6" data-id="element-1589">
                Security Settings
              </h2>
              <div className="space-y-4 max-w-md" data-id="element-1590">
                <div data-id="element-1591">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1592">
                    Current Password
                  </label>
                  <input type="password" placeholder="••••••••" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1593" />
                </div>
                <div data-id="element-1594">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1595">
                    New Password
                  </label>
                  <input type="password" placeholder="••••••••" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1596" />
                </div>
              </div>

              <div className="pt-6 border-t border-neutral-100" data-id="element-1597">
                <div className="flex items-center justify-between p-4 border border-neutral-200 rounded-xl" data-id="element-1598">
                  <div data-id="element-1599">
                    <h4 className="font-bold text-text" data-id="element-1600">
                      Two-Factor Authentication
                    </h4>
                    <p className="text-sm text-text-light" data-id="element-1601">
                      Add an extra layer of security to your account.
                    </p>
                  </div>
                  <div className="relative inline-block w-10 align-middle select-none transition duration-200 ease-in" data-id="element-1602">
                    <input type="checkbox" name="toggle" id="2fa" className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-4 appearance-none cursor-pointer transition-transform duration-200 ease-in-out border-neutral-300" data-id="element-1603" />
                    <label htmlFor="2fa" className="toggle-label block overflow-hidden h-5 rounded-full bg-neutral-300 cursor-pointer" data-id="element-1604"></label>
                  </div>
                </div>
              </div>
            </div>}

          {activeTab === 'notifications' && <div className="space-y-6 animate-in fade-in" data-id="element-1605">
              <h2 className="text-lg font-serif font-bold text-primary-900 mb-6" data-id="element-1606">
                Notification Preferences
              </h2>
              <div className="space-y-4" data-id="element-1607">
                {[{
              title: 'Email Notifications',
              desc: 'Receive updates about your account and listings via email.',
              checked: true
            }, {
              title: 'SMS Alerts',
              desc: 'Get text messages for important updates like inspection requests.',
              checked: false
            }, {
              title: 'Marketing Emails',
              desc: 'Receive news, special offers, and market reports.',
              checked: true
            }].map((item, i) => <div key={i} className="flex items-center justify-between p-4 border border-neutral-200 rounded-xl" data-id="element-1608">
                    <div data-id="element-1609">
                      <h4 className="font-bold text-text" data-id="element-1610">{item.title}</h4>
                      <p className="text-sm text-text-light" data-id="element-1611">{item.desc}</p>
                    </div>
                    <div className="relative inline-block w-10 align-middle select-none transition duration-200 ease-in" data-id="element-1612">
                      <input type="checkbox" defaultChecked={item.checked} className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-4 appearance-none cursor-pointer transition-transform duration-200 ease-in-out translate-x-5 border-secondary" data-id="element-1613" />
                      <label className="toggle-label block overflow-hidden h-5 rounded-full bg-secondary cursor-pointer" data-id="element-1614"></label>
                    </div>
                  </div>)}
              </div>
            </div>}
        </div>
      </div>
    </div>;
};